import { render } from "./Settings.vue?vue&type=template&id=aeec2a88&scoped=true&lang=pug"
import script from "./Settings.vue?vue&type=script&lang=ts"
export * from "./Settings.vue?vue&type=script&lang=ts"

import "./Settings.vue?vue&type=style&index=0&id=aeec2a88&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-aeec2a88"

export default script